import { Typography, Skeleton } from "@fullscript/aviary-web";
import { useState } from "react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Accordion } from "@aviary";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

interface Props {
  children: ReactNode;
  orderTotal: number;
  isLoading?: boolean;
}

const JourneyMobileOrderSummary = ({ children, orderTotal, isLoading = false }: Props) => {
  const { t } = useTranslation();
  const [accordion, setAccordion] = useState(false);

  const formatPrice = (price: number) => `$${price.toFixed(2)}`;

  return (
    <Accordion
      coreTriggerContent={
        <Typography variant="body">
          {t(
            accordion
              ? l.journeyCheckout.orderSummary.hideOrderSummary
              : l.journeyCheckout.orderSummary.showOrderSummary
          )}
        </Typography>
      }
      secondaryTriggerContent={
        isLoading ? (
          <Skeleton variant="typography" typographyType="body" width={5} />
        ) : (
          <Typography variant="body">{formatPrice(orderTotal)}</Typography>
        )
      }
      onChange={setAccordion}
      chevronPosition="start"
      isContentMarginless
    >
      {children}
    </Accordion>
  );
};

export { JourneyMobileOrderSummary };
